import { render, staticRenderFns } from "./sxgldxallist.vue?vue&type=template&id=6ff00a5f&scoped=true"
import script from "./sxgldxallist.vue?vue&type=script&lang=js"
export * from "./sxgldxallist.vue?vue&type=script&lang=js"
import style0 from "./sxgldxallist.vue?vue&type=style&index=0&id=6ff00a5f&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff00a5f",
  null
  
)

export default component.exports